/**
 * The override keys one volume-source edit writes, and therefore the keys one volume-source
 * revert must clear. The revert reads this list and the set's `overrides` literal is typed
 * against it, so a key added to one and not the other is a compile error.
 *
 * Kept out of the view module so the edit hook can read it without importing the component
 * that imports the hook.
 */
export const VOLUME_OVERRIDE_FIELDS = [
  'volumeSourceId',
  'volumeSourceType',
  'volumeSourceHref',
  'forecastSource',
  'dcaScenario',
] as const;
